/* Product media slider (Option B: left thumbs / right stage)
 * - Scopes everything to .product-media-root so multiple sections won't collide
 * - Keeps your HLS autoplay, modal zoom, swipe on stage & modal
 */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-media-root').forEach(initProductMedia);
});


function initProductMedia(root) {
  const sectionId = root.dataset.sectionId;

  // ===== Local state (per section) =====
  let currentMedia = [];
  let activeIndex = 0;
  let didInitialSort = false;
  let lastVariantId = null;
  function indexOfFirst(type, list) {
  const i = list.findIndex(m => m.type === type);
  return i >= 0 ? i : 0;
}

  // JSON data
  const dataEl = root.querySelector('#ProductData-' + sectionId);
  if (!dataEl) return;
  const store = JSON.parse(dataEl.textContent);
  const { product, variant_galleries: galleries } = store || { product: null, variant_galleries: {} };

  // DOM refs (scoped)
  const modal         = root.querySelector('#ProductModal-' + sectionId);
  const modalCarousel = modal ? modal.querySelector('.product-media-modal__carousel') : null;
  const modalClose    = modal ? modal.querySelector('.product-media-modal__toggle') : null;
  const pdpSticky   =  document.getElementsByClassName('pdp-sticky-left'); 
  const stage         = root.querySelector('#variant-media-stage');
  const thumbs        = root.querySelector('#variant-media-thumbs');
  const tPrev         = root.querySelector('.thumbs-prev');
  const tNext         = root.querySelector('.thumbs-next');
  // const prevBtn       = root.querySelector('.stage-prev');
  // const nextBtn       = root.querySelector('.stage-next');

  const optionInputs  = root.querySelectorAll('[name^="option"]');
  const variantSelect = root.querySelector('select.js-product-select--' + sectionId);

  // Track hls.js instances per <video> for cleanup
  const hlsMap = new WeakMap();

  // ---------- Helpers ----------
  function destroyHls(videoEl) {
    const hls = hlsMap.get(videoEl);
    if (hls) {
      try { hls.destroy(); } catch (e) {}
      hlsMap.delete(videoEl);
    }
  }
const OG_DEBUG = true;
  const ogLog  = (...a) => OG_DEBUG && console.log('[OG]', ...a);
  const ogWarn = (...a) => OG_DEBUG && console.warn('[OG]', ...a);

  function ensureMeta(attr, value) {
    let el = document.head.querySelector(`meta[${attr}="${value}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, value);
      document.head.appendChild(el);
    }
    return el;
  }

  function normalizeHttpsAbsolute(url) {
    if (!url) return '';
    try {
      const u = new URL(url, window.location.origin);
      u.protocol = 'https:';
      return u.href;
    } catch (e) {
      return '';
    }
  }

  function updateOgImageFromActive() {
    if (!currentMedia?.length) {
      ogWarn('no currentMedia, skip OG update');
      return;
    }

    // Always base OG preview on the FIRST IMAGE in the
    // current variant's media, not the current slide.
    const imgItem =
      currentMedia.find(m => m.type === 'image' && m.src) ||
      null;

    const fallbackItem =
      imgItem ||
      currentMedia.find(m => m.preview || m.poster) ||
      currentMedia[0];

    if (!fallbackItem) return;

    const raw =
      (fallbackItem.type === 'image' && fallbackItem.src) ||
      (fallbackItem.type === 'video' && (fallbackItem.preview || fallbackItem.poster || '')) ||
      '';

    const img = normalizeHttpsAbsolute(raw);
    if (!img) {
      ogWarn('could not resolve active media image for OG', item);
      return;
    }

    ensureMeta('property', 'og:image').setAttribute('content', img);
    ensureMeta('property', 'og:image:secure_url').setAttribute('content', img);
    ensureMeta('name', 'twitter:image').setAttribute('content', img);
  }

 function updateUrlVariantParam(variantId) {
  if (!variantId) return;

  const u = new URL(window.location.href);
  u.searchParams.set('variant', String(variantId));

  const finalUrl = u.toString();
  history.replaceState({}, '', finalUrl);

  // ✅ Update og:url
  const ogUrlMeta = document.head.querySelector('meta[property="og:url"]');
  if (ogUrlMeta) {
    ogUrlMeta.setAttribute('content', finalUrl);
  }

  // ✅ Update canonical
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', finalUrl);

  ogLog('URL + OG + Canonical updated', finalUrl);
}

  function pauseAllVideos(scopeEl) {
    (scopeEl || root).querySelectorAll('video').forEach(v => {
      try { v.pause(); } catch (e) {}
    });
  }

  // Force autoplay and keep it alive
  function forceAutoplay(videoEl) {
    videoEl.muted = true;
    videoEl.setAttribute('muted','');
    videoEl.setAttribute('playsinline','');
    videoEl.setAttribute('webkit-playsinline','');
    videoEl.setAttribute('loading','eager');
    videoEl.autoplay = true;
    videoEl.loop = true;
    videoEl.dataset.autoresume = '1';

    const tryPlay = () =>
      videoEl.play().catch(() => {
        setTimeout(() => videoEl.play().catch(()=>{}), 50);
      });

    videoEl.addEventListener('ended', () => {
      try { videoEl.currentTime = 0; } catch(e) {}
      tryPlay();
    });

    videoEl.addEventListener('pause', () => {
      if (!document.hidden && videoEl.dataset.autoresume === '1') tryPlay();
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && videoEl.dataset.autoresume === '1' && videoEl.paused) tryPlay();
    });

    tryPlay();
  }

  // Attach HLS + resilient autoplay
  function attachHls(videoEl, src) {
    videoEl.setAttribute('preload', 'auto');

    if (window.Hls && Hls.isSupported()) {
      const hls = new Hls({
        startLevel: -1,
        capLevelToPlayerSize: true,
        startFragPrefetch: true,
        maxBufferLength: 10
      });

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const targetWidth = Math.ceil((videoEl.clientWidth || 600) * (window.devicePixelRatio || 1));
        let best = 0;
        hls.levels.forEach((lvl, i) => { if (lvl.width && lvl.width <= targetWidth) best = i; });
        hls.currentLevel = Math.min(best + 1, hls.levels.length - 1);
        try { videoEl.play().catch(()=>{}); } catch(e) {}
      });

      hls.on(Hls.Events.ERROR, (e, data) => {
        if (data?.fatal === false) {
          try { videoEl.play().catch(()=>{}); } catch(e) {}
        }
      });

      hls.loadSource(src);
      hls.attachMedia(videoEl);
      hlsMap.set(videoEl, hls);
    } else if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
      // Native HLS
      videoEl.src = src;
    } else {
      videoEl.src = src;
    }

    forceAutoplay(videoEl);
  }

  function attachVideoSource(videoEl, src) {
  if (!src) return;

  videoEl.setAttribute('preload', 'metadata');

  const isHls = /\.m3u8($|\?)/i.test(src) || /application\/vnd\.apple\.mpegurl/i.test(src);

  if (isHls) {
    if (window.Hls && Hls.isSupported()) {
      const hls = new Hls({
        startLevel: -1,
        capLevelToPlayerSize: true,
        startFragPrefetch: true,
        maxBufferLength: 10
      });

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        try { videoEl.play().catch(() => {}); } catch (e) {}
      });

      hls.on(Hls.Events.ERROR, (e, data) => {
        if (data && data.fatal) {
          try { hls.destroy(); } catch (err) {}
        }
      });

      hls.loadSource(src);
      hls.attachMedia(videoEl);
      hlsMap.set(videoEl, hls);
    } else if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
      videoEl.src = src;
    } else {
      videoEl.src = src;
    }
  } else {
    destroyHls(videoEl);
    videoEl.src = src;
  }

  forceAutoplay(videoEl);
}


  // Swipe helper: horizontal swipe → prev/next
  function enableSwipe(container, onPrev, onNext) {
    let startX = 0, startY = 0, isDown = false, isH = false, moved = false;
    const THRESHOLD = 40;   // px needed to trigger slide
    const ANGLE_LOCK = 10;  // px before we decide direction

    function onPointerDown(e) {
      const t = e.touches ? e.touches[0] : e;
      startX = t.clientX; startY = t.clientY;
      isDown = true; isH = false; moved = false;
    }
    function onPointerMove(e) {
      if (!isDown) return;
      const t = e.touches ? e.touches[0] : e;
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      if (!isH && (Math.abs(dx) > ANGLE_LOCK || Math.abs(dy) > ANGLE_LOCK)) {
        isH = Math.abs(dx) > Math.abs(dy);
      }
      if (isH) {
        e.preventDefault();
        moved = true;
      }
    }
    function onPointerUp(e) {
      if (!isDown) return;
      isDown = false;

      if (!moved) return;
      const t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : e;
      const dx = t.clientX - startX;

      if (Math.abs(dx) >= THRESHOLD) {
        if (dx < 0) onNext(); else onPrev();
      }
    }

    // Touch
    container.addEventListener('touchstart', onPointerDown, { passive: true });
    container.addEventListener('touchmove',  onPointerMove,  { passive: false });
    container.addEventListener('touchend',   onPointerUp,    { passive: true });

    // Pointer (optional)
    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointermove', onPointerMove);
    container.addEventListener('pointerup',   onPointerUp);
  }

  function initialIndexFor(mediaItems) {
    const vi = mediaItems.findIndex(m => m.type === 'video' && (m.sources?.[0]?.url));
    return vi >= 0 ? vi : 0;
  }

  // ---------- Modal ----------
  function openMediaModal(src) {
    if (!modal || !modalCarousel) return;
      if (isMobile()) return;
    // Pause stage videos to free bandwidth
     if (pdpSticky[0]) pdpSticky[0].style.position = "static";
    const stageScope = stage || root;
    pauseAllVideos(stageScope);

    const startIndex = currentMedia.findIndex(item =>
      (item.type === 'image' && item.src === src) ||
      (item.type === 'video' && item.sources?.[0]?.url === src)
    );
    if (startIndex === -1) return;

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    renderModalCarousel(startIndex);
    
  }

  function renderModalCarousel(startIndex) {
    // Cleanup previous
    modalCarousel.querySelectorAll('video').forEach(destroyHls);
    modalCarousel.innerHTML = '';

    currentMedia.forEach((media, idx) => {
      const div = document.createElement('div');
      div.className = `media-carousel-item ${idx === startIndex ? 'active' : ''}`;
      div.dataset.index = idx;

      if (media.type === 'image') {
        div.innerHTML = `<img src="${media.src}" alt="Product image ${idx + 1}">`;
      } else if (media.sources?.[0]?.url) {
        const poster = media.preview ? `poster="${media.preview}"` : '';
        div.innerHTML = `
          <video
            controls
            autoplay
            loop
            playsinline
            muted
            preload="auto"
            ${poster}
            id="modalVideo-${sectionId}-${idx}"
            style="max-width:680px;max-height:100%;"
          ></video>
        `;
        setTimeout(() => {
          const vid = root.querySelector(`#modalVideo-${sectionId}-${idx}`) || document.getElementById(`modalVideo-${sectionId}-${idx}`);
          if (vid) attachHls(vid, media.sources[0].url);
        }, 0);
      }

      modalCarousel.appendChild(div);
    });

    modalCarousel.insertAdjacentHTML('beforeend', `
      <button class="carousel-nav carousel-prev">❮</button>
      <button class="carousel-nav carousel-next">❯</button>
    `);

    modalCarousel.querySelector('.carousel-prev').addEventListener('click', () => slideModal(-1));
    modalCarousel.querySelector('.carousel-next').addEventListener('click', () => slideModal(+1));

    // Swipe inside modal
    enableSwipe(modalCarousel, () => slideModal(-1), () => slideModal(+1));

    if (modalClose) modalClose.addEventListener('click', closeModalAndCleanup, { once: true });
    if (modal) {
      modal.addEventListener('click', e => {
        if (e.target === modal) closeModalAndCleanup();
      }, { once: true });
    }
  }

  function slideModal(dir) {
    const active = modalCarousel.querySelector('.media-carousel-item.active');
    if (!active) return;
    const idx = parseInt(active.dataset.index, 10);
    const nextIdx = (idx + dir + currentMedia.length) % currentMedia.length;

    active.classList.remove('active');
    const nextEl = modalCarousel.querySelector(`.media-carousel-item[data-index="${nextIdx}"]`);
    if (nextEl) nextEl.classList.add('active');

    const nextVideo = nextEl ? nextEl.querySelector('video') : null;
    if (nextVideo) {
      try { nextVideo.currentTime = 0; nextVideo.play(); } catch (e) {}
    }
  }

  function closeModalAndCleanup() {
    if (!modal || !modalCarousel) return;
    if (pdpSticky[0]) pdpSticky[0].style.position = "sticky";
    modalCarousel.querySelectorAll('video').forEach(v => {
      try { v.pause(); } catch (e) {}
      destroyHls(v);
      try { v.removeAttribute('src'); v.load(); } catch (e) {}
    });

    modal.style.display = 'none';
    document.body.style.overflow = '';

    // Resume stage autoplay
    root.querySelectorAll('#variant-media-stage video').forEach(v => {
      try { v.play(); } catch (e) {}
    });
  }

  function getBestVideoSource(item) {
  if (!item || !Array.isArray(item.sources)) return '';
  const mp4 = item.sources.find(s =>
    (s.format && s.format.toLowerCase() === 'mp4') ||
    (s.mime_type && s.mime_type.toLowerCase().includes('mp4'))
  );
  if (mp4 && mp4.url) return mp4.url;

  const hls = item.sources.find(s =>
    (s.format && s.format.toLowerCase() === 'm3u8') ||
    (s.mime_type && s.mime_type.toLowerCase().includes('mpegurl')) ||
    (/\.m3u8($|\?)/i.test(s.url || ''))
  );
  if (hls && hls.url) return hls.url;

  return item.sources[0]?.url || '';
}


  // ---------- Slider (Option B) ----------
function renderMediaSlider(mediaItems, startIndex = 0) {
    if (!thumbs || !stage) return;

    // Cleanup previous videos
    stage.querySelectorAll('video').forEach(destroyHls);

    // Wire thumb nav buttons
    if (tPrev) tPrev.onclick = () => slideRelative(-1);
    if (tNext) tNext.onclick = () => slideRelative(+1);

    // (Optional) set equal-height rows if your CSS uses --thumb-count
     thumbs.style.setProperty('--thumb-count', String(4));

    thumbs.innerHTML = '';
    stage.innerHTML  = '';
    teardownZoom();
    stage.querySelectorAll('video').forEach(destroyHls);
    thumbs.innerHTML = '';
    stage.innerHTML  = '';
    mediaItems.forEach((item, index) => {
      // THUMB
      const t = document.createElement('div');
      t.className = 'media-thumb';
      t.dataset.index = index;

      const thumbImg = document.createElement('img');
      thumbImg.loading = 'lazy';
      thumbImg.src = (item.type === 'image') ? (item.preview || item.src) : (item.preview || '');
      thumbImg.alt = (item.type === 'image') ? 'Product thumbnail' : 'Video thumbnail';
      t.appendChild(thumbImg);
      t.addEventListener('click', () => slideTo(index));
      thumbs.appendChild(t);

      const VISIBLE = 4;      // visible thumbs
      const THUMB = 150;       // px – square side; keep in sync with CSS --thumb-size
      const GAP = 12;          // px – keep in sync with CSS --thumb-gap
      thumbs.style.setProperty('--thumb-size', THUMB + 'px');
      thumbs.style.setProperty('--thumb-gap', GAP + 'px');

       if (isMobile()) {
      thumbs.style.overflowX = 'auto';
      thumbs.style.overflowY = 'hidden';
    } else {
      thumbs.style.overflowY = 'auto';
      thumbs.style.overflowX = 'hidden';
    }

      // Exact max-height so exactly 4 squares (with gaps) are visible
    //  thumbs.style.maxHeight = (VISIBLE * THUMB + (VISIBLE - 1) * GAP) + 'px';
      thumbs.style.overflowY = 'hidden';
      thumbs.style.webkitOverflowScrolling = 'touch';

      // Smooth scroll: keep active thumb visible
      const scrollActiveIntoView = () => {
        const activeThumb = root.querySelector(`.media-thumb[data-index="${activeIndex}"]`);
        if (activeThumb?.scrollIntoView) {
          activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      };
      // STAGE item
      const s = document.createElement('div');
      s.className = 'stage-item';
      s.dataset.index = index;

      if (item.type === 'image') {
        s.innerHTML = `
          <img
            src="${item.src}"
            alt="Product image ${index + 1}"
            class="zoom-enabled"
            data-src="${item.src}"
            data-type="image"
          >`;
      } else {
        const poster = item.preview ? `poster="${item.preview}"` : '';
        s.innerHTML = `
          <video
            autoplay
            loop
            playsinline
            muted
            preload="auto"
            ${poster}
            class="zoom-enabled"
            data-src="${getBestVideoSource(item)}"
            data-type="video"
            data-poster="${item.preview || ''}"
            style="max-width:100%;max-height:100%;"
          ></video>`;
      }

      stage.appendChild(s);
    });

    // Start with first video if any
    // activeIndex = Math.min(activeIndex, Math.max(0, mediaItems.length - 1));
    // if (activeIndex === 0) {
    //   activeIndex = initialIndexFor(mediaItems);
    // }
  activeIndex = Math.max(0, Math.min(startIndex, mediaItems.length - 1));
    // Swipe on stage
    enableSwipe(stage, () => slideRelative(-1), () => slideRelative(+1));

    refreshActiveSlide();

    // Stage arrows
    // if (prevBtn) prevBtn.onclick = () => slideRelative(-1);
    // if (nextBtn) nextBtn.onclick = () => slideRelative(+1);

    // Keyboard nav
    stage.tabIndex = 0;
    stage.onkeydown = (e) => {
      if (e.key === 'ArrowLeft') slideRelative(-1);
      if (e.key === 'ArrowRight') slideRelative(+1);
    };

    // Click-to-zoom
    stage.querySelectorAll('.zoom-enabled').forEach(elm => {
      elm.addEventListener('click', (e) => {
        if (isMobile()) {
          // handled by PinchPanZoom (single/double tap)
          e.preventDefault();
          return;
        }
        const src = elm.dataset.src;
        openMediaModal(src);
      });
    });
  }
 function scrollThumbsToActive() {
  if (!thumbs) return;
  const activeThumb = root.querySelector(`.media-thumb[data-index="${activeIndex}"]`);
  if (!activeThumb) return;

  const stripRect = thumbs.getBoundingClientRect();
  const itemRect  = activeThumb.getBoundingClientRect();

  if (isMobile()) {
    // Horizontal scrolling on mobile (left ↔ right)
    const stripCenter = stripRect.left + stripRect.width / 2;
    const itemCenter  = itemRect.left + itemRect.width / 2;
    const delta       = itemCenter - stripCenter;

    const targetLeft = thumbs.scrollLeft + delta;
    thumbs.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });
  } else {
    // Vertical scrolling on desktop (up ↕ down)
    const stripCenter = stripRect.top + stripRect.height / 2;
    const itemCenter  = itemRect.top + itemRect.height / 2;
    const delta       = itemCenter - stripCenter;

    const targetTop = thumbs.scrollTop + delta;
    thumbs.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  }
}




  function refreshActiveSlide() {
    // Thumbs active state
    root.querySelectorAll('.media-thumb').forEach((th, i) => {
      th.classList.toggle('is-active', i === activeIndex);
    });

    // Stage show/hide + lazy HLS
    const items = root.querySelectorAll('.stage-item');
    items.forEach((it, i) => {
      const isActive = i === activeIndex;
      it.classList.toggle('is-active', isActive);

      if (isActive) {
        const v = it.querySelector('video');
        if (v && !hlsMap.get(v)) {
          const src = v.dataset.src;
          const poster = v.dataset.poster;
          if (poster) v.setAttribute('poster', poster);
          if (src) attachVideoSource(v, src);
        }
      } else {
        const v = it.querySelector('video');
        if (v) { try { v.pause(); } catch(e) {} }
      }
    });

    // Keep active thumb in view
      const activeThumb = root.querySelector(`.media-thumb[data-index="${activeIndex}"]`);
      if (activeThumb?.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }

    scrollThumbsToActive();
    setupZoomForActive();
  updateOgImageFromActive();
  }

  function slideRelative(step) {
    if (!currentMedia.length) return;
    activeIndex = (activeIndex + step + currentMedia.length) % currentMedia.length;
    refreshActiveSlide();
  }

  function slideTo(index) {
    if (!currentMedia.length) return;
    activeIndex = Math.max(0, Math.min(index, currentMedia.length - 1));
    refreshActiveSlide();
  }

  // ---------- Variant handling ----------
function getMediaForVariant(variantId, { sortVideos = false } = {}) {
  const list = (galleries[String(variantId)] || []).slice();
  if (sortVideos) {
    list.sort((a, b) => (a.type === 'video' ? 0 : 1) - (b.type === 'video' ? 0 : 1));
    }
    return list;
  }

  function updateCurrentMedia(media) {
    currentMedia = media || [];
    activeIndex = 0; // reset on variant change (we'll jump to first video in render)
    
  }

  function activeVariant() {
    return product.variants.find(v =>
      v.options.every((val, i) =>
        val === root.querySelector(`input[name="option${i + 1}"]:checked`)?.value
      )
    );
  }

  function syncForm(variant) {
    if (!variantSelect) return;
    const prev = variantSelect.value;
    const next = String(variant.id);
    variantSelect.value = next;

    if (prev !== next) {
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const addButton = root.querySelector('.btn--add-to-cart') || document.querySelector('.btn--add-to-cart');
    if (addButton) addButton.disabled = !variant.available;
  }
  // ---------- Variant helpers (robust) ----------
function findVariantById(id) {
  const vid = typeof id === 'string' ? parseInt(id, 10) : id;
  return product.variants.find(v => v.id === vid);
}

  // --- Mobile detection (live) ---
  const mqMobile = window.matchMedia('(max-width: 768px)');
  const isMobile = () => mqMobile.matches;

  // --- Simple pinch+pan zoom controller for one IMG element ---
  class PinchPanZoom {
    tapTime = 0;
    tapX = 0;
    tapY = 0;
    TAP_DELAY = 280;    // ms between taps
    TAP_SLOP  = 20;     // px distance allowed between taps

    constructor(imgEl) {
      this.el = imgEl;
      this.scale = 1;
      this.minScale = 1;
      this.maxScale = 3;
      this.tx = 0; // translateX
      this.ty = 0; // translateY

      this.startDist = 0;
      this.startScale = 1;
      this.startMid = { x: 0, y: 0 };
      this.lastTap = 0;
      this.dragStart = null;
      
      this.el.classList.add('zoom-canvas');
      this.el.style.touchAction = 'pan-y';

      // Bind
      this._onTouchStart = this.onTouchStart.bind(this);
      this._onTouchMove  = this.onTouchMove.bind(this);
      this._onTouchEnd   = this.onTouchEnd.bind(this);
      this._onDblClick   = this.onDblClick.bind(this);

      this.el.addEventListener('touchstart', this._onTouchStart, { passive: false });
      this.el.addEventListener('touchmove',  this._onTouchMove,  { passive: false });
      this.el.addEventListener('touchend',   this._onTouchEnd,   { passive: false });

      // Desktop simulators can still use dblclick, but mobile uses touchend
      this.el.addEventListener('dblclick',   this._onDblClick);
      this.apply();
    }

    destroy() {
      this.el.removeEventListener('touchstart', this._onTouchStart);
      this.el.removeEventListener('touchmove',  this._onTouchMove);
      this.el.removeEventListener('touchend',   this._onTouchEnd);
      this.el.removeEventListener('dblclick',   this._onDblClick);
      this.el.classList.remove('zoom-canvas','zooming');
      this.el.style.transform = '';
    }

    clamp() {
      // Keep image inside its box when panning (rough bounds)
      const rect = this.el.getBoundingClientRect();
      const parent = this.el.parentElement.getBoundingClientRect();
      const overX = Math.max(0, (rect.width  * this.scale - parent.width)  / 2);
      const overY = Math.max(0, (rect.height * this.scale - parent.height) / 2);
      this.tx = Math.max(-overX, Math.min(overX, this.tx));
      this.ty = Math.max(-overY, Math.min(overY, this.ty));
    }

    apply() {
      this.clamp();
      this.el.style.transform = `translate3d(${this.tx}px, ${this.ty}px, 0) scale(${this.scale})`;
      if (this.scale > 1.01) {
        this.el.classList.add('zoom-locked');
        this.el.style.touchAction = 'none';
      } else {
        this.el.classList.remove('zoom-locked');
        this.el.style.touchAction = 'pan-y';
      }
    }

    distance(t1, t2) {
      const dx = t2.clientX - t1.clientX;
      const dy = t2.clientY - t1.clientY;
      return Math.hypot(dx, dy);
    }

    midpoint(t1, t2) {
      return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
    }

    toLocal(pt) {
      const r = this.el.getBoundingClientRect();
      return { x: pt.x - r.left - r.width/2, y: pt.y - r.top - r.height/2 };
    }

    onTouchStart(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        const [t1, t2] = e.touches;
        this.startDist  = this.distance(t1, t2);
        this.startScale = this.scale;
        this.startMid   = this.midpoint(t1, t2);
        this.el.classList.add('zooming');
        this.dragStart = null;
      } else if (e.touches.length === 1 && this.scale > 1) {
        // pan
        e.preventDefault();
        const t = e.touches[0];
        this.dragStart = { x: t.clientX - this.tx, y: t.clientY - this.ty };
        this.el.classList.add('zooming');
      }
    }

    onTouchMove(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        const [t1, t2] = e.touches;
        const dist = this.distance(t1, t2);
        const mid  = this.midpoint(t1, t2);

        let nextScale = (this.startScale * dist) / Math.max(1, this.startDist);
        nextScale = Math.max(this.minScale, Math.min(this.maxScale, nextScale));

        // zoom towards pinch midpoint (basic focal zoom)
        const midLocal = this.toLocal(mid);
        const k = nextScale / this.scale;
        this.tx = k * (this.tx + midLocal.x) - midLocal.x;
        this.ty = k * (this.ty + midLocal.y) - midLocal.y;

        this.scale = nextScale;
        this.apply();
      } else if (e.touches.length === 1 && this.dragStart) {
        e.preventDefault();
        const t = e.touches[0];
        this.tx = t.clientX - this.dragStart.x;
        this.ty = t.clientY - this.dragStart.y;
        this.apply();
      }
    }

   onTouchEnd(e) {
      // Stop pan/zoom states
      this.el.classList.remove('zooming');
      this.dragStart = null;

      // Snap back if tiny zoom
      if (this.scale <= 1.01) {
        this.scale = 1; this.tx = 0; this.ty = 0;
        this.apply();
      }

      // ---- Double-tap detection on mobile ----
      if (e.changedTouches && e.changedTouches.length === 1) {
        e.preventDefault(); // prevent browser’s own double-tap behaviors
        const t = e.changedTouches[0];
        const now = Date.now();

        if (
          now - this.tapTime <= this.TAP_DELAY &&
          Math.abs(t.clientX - this.tapX) <= this.TAP_SLOP &&
          Math.abs(t.clientY - this.tapY) <= this.TAP_SLOP
        ) {
          // Detected a double-tap
          this.tapTime = 0;
          this.handleDoubleTap(e);
          return;
        }

        // First tap: store and wait for second
        this.tapTime = now;
        this.tapX = t.clientX;
        this.tapY = t.clientY;
      }
    }


    onDblClick() {
      this.toggleZoom();
    }

    onSingleTap(e) {
      // Mobile single-tap = zoom in/out (double-tap simulation)
      if (!isMobile()) return; // keep desktop modal behavior elsewhere
      const now = Date.now();
      if (now - this.lastTap < 300) {
        this.toggleZoom(e);
        this.lastTap = 0;
      } else {
        this.lastTap = now;
      }
    }

    handleDoubleTap(e) {
      // Called from onTouchEnd() when we have a candidate double-tap
      const t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
      if (!t) return;

      // Toggle: if zoomed in -> zoom OUT to 1; else -> zoom IN around tap point
      if (this.scale > 1) {
        this.scale = 1;
        this.tx = 0;
        this.ty = 0;
      } else {
        this.scale = 2; // or 2.5/3 if you want stronger
        const pt = { x: t.clientX, y: t.clientY };
        const local = this.toLocal(pt);
        this.tx = -local.x;
        this.ty = -local.y;
      }
      this.apply();
    }


    toggleZoom(e) {
      if (this.scale === 1) {
        this.scale = 2; // zoom in
        if (e) {
          const pt = { x: e.clientX ?? (e.touches?.[0]?.clientX || 0),
                       y: e.clientY ?? (e.touches?.[0]?.clientY || 0) };
          const local = this.toLocal(pt);
          this.tx = -local.x; this.ty = -local.y;
        }
      } else {
        this.scale = 1; this.tx = 0; this.ty = 0;
      }
      this.apply();
    }
  }

  // Keep one zoom controller per active image
  let activeZoom = null;
  function teardownZoom() {
    if (activeZoom) { activeZoom.destroy(); activeZoom = null; }
  }

function setupZoomForActive() {
  teardownZoom();
  if (!isMobile()) return;
  const activeImg = root.querySelector('.stage-item.is-active img.zoom-enabled');
  if (activeImg) {
    activeImg.setAttribute('draggable', 'false');
    activeImg.addEventListener('contextmenu', e => e.preventDefault(), { passive: false });
    activeZoom = new PinchPanZoom(activeImg);
  }
}

function variantFromSelectedOptions() {
  // Try inside section first, then document as fallback
  const getVal = (i) =>
    (root.querySelector(`input[name="option${i}"]:checked`) ||
     document.querySelector(`input[name="option${i}"]:checked`))?.value;

  // Some themes use <select name="options[Size]">; support both forms
  const getValByIndexOrName = (i, nameFallback) => {
    const radio = (root.querySelector(`input[name="option${i}"]:checked`) ||
                   document.querySelector(`input[name="option${i}"]:checked`));
    if (radio) return radio.value;

    const sel = (root.querySelector(`select[name="option${i}"]`) ||
                 document.querySelector(`select[name="option${i}"]`) ||
                 (nameFallback ? (root.querySelector(`select[name="${nameFallback}"]`) ||
                                  document.querySelector(`select[name="${nameFallback}"]`)) : null));
    return sel ? sel.value : undefined;
  };

  // Build selected options array matching product.options order
  const values = product.options.map((optName, idx) =>
    getValByIndexOrName(idx + 1, `options[${optName}]`)
  );

  if (values.some(v => v === undefined)) return null;

  return product.variants.find(v =>
    v.options.every((val, i) => val === values[i])
  );
}

function variantFromSelectId() {
  // Prefer the section-scoped select; fallback to document
  const sel =
    root.querySelector('select[name="id"]') ||
    root.querySelector(`select.js-product-select--${sectionId}`) ||
    document.querySelector('select[name="id"]') ||
    document.querySelector(`select.js-product-select--${sectionId}`);

  if (!sel || !sel.value) return null;
  return findVariantById(sel.value);
}

function getActiveVariant() {
  // 1) If a select[name="id"] exists, it’s authoritative
  const byId = variantFromSelectId();
  if (byId) return byId;

  // 2) Otherwise derive by selected options
  const byOpts = variantFromSelectedOptions();
  if (byOpts) return byOpts;

  // 3) Fallback
  return product.selected_or_first_available_variant || product.variants[0];
}

 function updateMediaForVariant(variant) {
    if (!variant) return;

    const mediaItems = getMediaForVariant(variant.id); // preserve Shopify order

    // Always start on the very first media item (index 0),
    // whether it is an image or a video.
    const startIndex = 0;

    updateCurrentMedia(mediaItems);
    renderMediaSlider(mediaItems, startIndex);
    syncForm(variant);

    lastVariantId = variant.id;
    // Keep URL + social meta in sync with the active variant
    updateUrlVariantParam(variant.id);
    updateOgImageFromActive();
  }

// ---------- Variant event wiring (resilient) ----------
function bindVariantEvents() {
  // 1) Direct change listeners for section-scoped inputs/selects (if present)
  const localOptionInputs = root.querySelectorAll('[name^="option"]');
  localOptionInputs.forEach(inp => {
    inp.addEventListener('change', () => {
      const v = getActiveVariant();
      updateMediaForVariant(v);
    });
  });

  const localVariantSelect =
    root.querySelector('select[name="id"]') ||
    root.querySelector(`select.js-product-select--${sectionId}`);
  if (localVariantSelect) {
    localVariantSelect.addEventListener('change', () => {
      const v = getActiveVariant();
      updateMediaForVariant(v);
    });
  }

  // 2) Document-level delegation (covers inputs/selects rendered outside this section)
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    // option radios/selects
    if (t.matches('[name^="option"]') || t.matches('select[name^="options["]')) {
      const v = getActiveVariant();
      updateMediaForVariant(v);
    }

    // select[name="id"] (Shopify variant select)
    if (t.matches('select[name="id"]')) {
      const v = getActiveVariant();
      updateMediaForVariant(v);
    }
  });

  // 3) Dawn-style custom event bubbling from product-form
  document.addEventListener('variant:change', (evt) => {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    // If your theme includes product_id in detail, you can scope like:
    // if (evt.detail.product && evt.detail.product.id !== product.id) return;

    // Otherwise, we trust the active select/options for this page
    updateMediaForVariant(variant);
  }, false);
}

// ---------- Init (replace your previous DOMContentLoaded variant section) ----------
(function initVariants() {
 bindVariantEvents();
   const urlParam = new URLSearchParams(window.location.search).get('variant');
      let firstVariant =
        (urlParam && findVariantById(urlParam)) ||
        getActiveVariant();

    const firstMedia = getMediaForVariant(firstVariant.id);   // preserve order
    const firstStart = 0;                                     // first element (image or video)
    updateCurrentMedia(firstMedia);
    renderMediaSlider(firstMedia, firstStart);
    syncForm(firstVariant);
    lastVariantId = firstVariant.id;  
 
  // Shopify editor/section events may pause media
  ['shopify:section:load','shopify:section:select','shopify:block:select'].forEach(evt => {
    document.addEventListener(evt, () => {
      root.querySelectorAll('#variant-media-stage video').forEach(v => {
        try { v.play(); } catch(e) {}
      });
    });
  });
})();



 


  // ---------- (Optional) Shape → button onclick rewiring ----------
  // If your shape controls/buttons sit inside this section, keep it scoped; otherwise,
  // you can move this out to wherever those controls live.
  const shapeInputSelector = '.shape-input:checked';
  function updateButtonsWithShape() {
    const shapeInput = document.querySelector(shapeInputSelector); // likely outside root
    if (!shapeInput) return;
    const shape = shapeInput.value.trim().toLowerCase().replace(/\s+/g, '-');
    const buttons = document.querySelectorAll('#choose-diamond-1 .add_setting');
    buttons.forEach((btn) => {
      const originalOnClick = btn.getAttribute('onclick');
      if (!originalOnClick) return;
      const match = originalOnClick.match(/chooseDiamond\('([^']+)'/);
      if (!match || !match[1]) return;
      const basePath = match[1].split('/')[0];
      const newOnClick = `chooseDiamond('${basePath}/${shape}', 'product', event)`;
      btn.setAttribute('onclick', newOnClick);
    });
  }
  setTimeout(updateButtonsWithShape, 1000);
  document.querySelectorAll('.shape-input').forEach(input => {
    input.addEventListener('change', updateButtonsWithShape);
  });
  updateButtonsWithShape();
}
(function () {
  const mq = window.matchMedia('(min-width: 992px)');
  const leftCol  = document.querySelector('.bwp-single-image'); // gallery column
  const rightCol = document.querySelector('.bwp-single-info');  // info column
  if (!leftCol || !rightCol) return;

  // Compute top offset under your fixed header
  function computeHeaderOffset() {
    const fixedHeader = document.querySelector('.site-header, .header, .navbar, .bwp-header');
    const extraGap = 12;
    const h = fixedHeader && getComputedStyle(fixedHeader).position === 'fixed'
      ? fixedHeader.offsetHeight + extraGap
      : 96; // fallback
    document.documentElement.style.setProperty('--sticky-top', h + 'px');
  }

  function px(n) { return Math.max(0, Math.round(n)) + 'px'; }

  let rafId = 0;
  function update() {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      if (!mq.matches) {
        leftCol.style.minHeight = '';
        document.documentElement.style.setProperty('--sticky-top', '0px');
        return;
      }
      computeHeaderOffset();
      // Make left column as tall as the right column so sticky will stop at the same bottom
      leftCol.style.minHeight = px(rightCol.getBoundingClientRect().height);
    });
  }

  const ro = new ResizeObserver(update);
  ro.observe(rightCol);
  ro.observe(leftCol);

  // Media in both columns can change height
  [...leftCol.querySelectorAll('img, video'), ...rightCol.querySelectorAll('img, video')].forEach(el => {
    el.addEventListener('load', update, { passive: true });
    el.addEventListener('loadedmetadata', update, { passive: true });
  });

  window.addEventListener('load', update);
  window.addEventListener('resize', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:select', update);

  update();
})();

